<template>
  <v-row dense>
    <v-col cols="12" md="12" sm="12">
      <v-col v-for="(inputAntecedents, index) in inputAntecedents" :key="index">
        <v-row dense>
          <v-col cols="12" sm="12" md="12">
            <v-banner
              color="blue-grey lighten-5"
              class="black--text"
              shaped
              single-line
            >
              {{ inputAntecedents.name }}
            </v-banner>
          </v-col>
          <v-col
            :cols="calculeCols(inputAntecedents.questions.length)"
            v-for="(question, subindex) in inputAntecedents.questions"
            :key="subindex"
            class="pl-5"
          >
            <span v-if="question.typeAnswer == $cnst.ANSWER_TYPE_OPEN">
              <strong>{{ question.name }}:</strong><br />
              {{ question.answerOpen }}
            </span>
            <span
              v-if="
                question.typeAnswer == $cnst.ANSWER_TYPE_CLOSED ||
                  question.typeAnswer == $cnst.ANSWER_TYPE_COMBINED
              "
            >
              <strong>{{ question.name }}:</strong><br />{{
                question.answerClosedName
              }}</span
            >
            <span v-if="question.typeAnswer == $cnst.ANSWER_TYPE_MULTIPLE">
              <strong>{{ question.name }}:</strong><br />
              <span
                v-for="(anwers, answersindex) in question.answersClosed"
                :key="answersindex"
              >
                {{ anwers[answersindex] }}</span
              >
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  props: {
    model: Object,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      panelSV: 2,
      inputAntecedents: [],
    };
  },
  mounted() {
    this.fillAntecedents();
  },
  methods: {
    fillAntecedents() {
      this.inputAntecedents = this.model.antecedents;
    },
    calculeCols(cuantityQuestions) {
      switch (cuantityQuestions) {
        case 1:
          return "12";
          break;
        case 2:
          return "6";
          break;
        default:
          return "4";
          break;
      }
    },
  },
};
</script>
